var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHearticon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 19.25C15.5563 19.25 19.25 15.5563 19.25 11C19.25 6.44365 15.5563 2.75 11 2.75C6.44365 2.75 2.75 6.44365 2.75 11C2.75 15.5563 6.44365 19.25 11 19.25Z",
    fill: "url(#paint0_linear_9_11450)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8291 11.8114C12.4673 14.5695 11.2668 15.3817 11.2157 15.413C11.1529 15.4601 11.0745 15.4798 11 15.4798C10.9254 15.4798 10.8469 15.4601 10.7803 15.413C10.7332 15.3817 9.5327 14.5695 7.17086 11.8114C6.01737 10.4657 6.40576 8.84538 7.3866 7.93912C8.24583 7.14267 9.7053 6.82487 11 7.88806C12.2947 6.82487 13.7541 7.14267 14.6134 7.93912C15.5942 8.84538 15.9826 10.4657 14.8291 11.8114Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9_11450",
    x1: 11,
    y1: 19.25,
    x2: 11,
    y2: 2.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD142E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F75E7A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHearticon);
export default __webpack_public_path__ + "static/media/heart icon.168c77608988c2f783c6dc7ced7820b2.svg";
export { ForwardRef as ReactComponent };